import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countHelper", "selectedOption", "dropdownMenu"]
  static values = {
    initialCount: { type: Number, default: 0 }
  }

  connect() {
    console.log("[CreateQuoteHotlink] Controller connected")
    this.updateQuoteSelectedVisibility()

    // Listen for selection changes from other controllers
    document.addEventListener('securities-selection-changed', this.updateQuoteSelectedVisibility.bind(this))
  }

  disconnect() {
    // Clean up event listeners to prevent memory leaks
    document.removeEventListener('securities-selection-changed', this.updateQuoteSelectedVisibility.bind(this))
  }

  updateQuoteSelectedVisibility() {
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]")
    const count = selectedRows.length

    // Update visibility of selected options
    this.selectedOptionTargets.forEach(option => {
      if (count === 0) {
        option.classList.add('hidden')
      } else {
        option.classList.remove('hidden')
      }
    })

    // Update count display
    this.countHelperTargets.forEach(element => {
      element.textContent = `(${count})`
    })
  }

  // Method to be called from other controllers when selection changes
  refreshCount() {
    this.updateQuoteSelectedVisibility()
  }

  // Toggle dropdown visibility
  toggleDropdown(event) {
    event.preventDefault();
    console.log('[CreateQuoteHotlink] Toggle dropdown called');

    if (this.hasDropdownMenuTarget) {
      this.dropdownMenuTarget.classList.toggle('hidden');
    }
  }

  // Quote functionality methods
  createQuoteWithSelected(event) {
    event.preventDefault();
    console.log('[CreateQuoteHotlink] createQuoteWithSelected called');

    const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]");
    console.log('[CreateQuoteHotlink] Selected rows:', selectedRows);

    if (selectedRows.length === 0) {
      console.log('[CreateQuoteHotlink] No selected rows, opening modal without selections');
      document.dispatchEvent(new CustomEvent('open-quote-creation-modal'));
    } else {
      const selectedIsins = selectedRows.map(isin => isin.toUpperCase());
      console.log('[CreateQuoteHotlink] Opening modal with selected ISINs:', selectedIsins);
      document.dispatchEvent(new CustomEvent('open-quote-creation-modal', {
        detail: { selectedIsins: selectedIsins }
      }));
    }

    // Hide the dropdown after action
    if (this.hasDropdownMenuTarget) {
      this.dropdownMenuTarget.classList.add('hidden');
    }
  }

  createQuoteFromScratch(event) {
    event.preventDefault();
    console.log('[CreateQuoteHotlink] createQuoteFromScratch called, opening modal');
    document.dispatchEvent(new CustomEvent('open-quote-creation-modal'));

    // Hide the dropdown after action
    if (this.hasDropdownMenuTarget) {
      this.dropdownMenuTarget.classList.add('hidden');
    }
  }
}
